import { createSlice } from "@reduxjs/toolkit";

const initialObjectState = null;
const modalsStructure = {
  delete: {
    open: false,
    id: null,
  },
  edit: {
    open: false,
    object: initialObjectState,
  },
};

const initialState = {
  sections: {
    section: { modals: { ...modalsStructure } },
    page: { modals: { ...modalsStructure } },
  },
};

const adminConsoleConfigControlSlice = createSlice({
  name: "adminConsoleConfigControl",
  initialState: initialState,
  reducers: {
    openDeleteModal: (state, action) => {
      const { section, id } = action.payload;
      state.sections[section].modals.delete = { open: true, id };
    },
    closeDeleteModal: (state, action) => {
      const { section } = action.payload;
      state.sections[section].modals.delete = { open: false, id: null };
    },
    openEditModal: (state, action) => {
      const { section, object } = action.payload;
      state.sections[section].modals.edit = { open: true, object };
    },
    closeEditModal: (state, action) => {
      const { section } = action.payload;
      state.sections[section].modals.edit = { open: false, object: initialObjectState };
    },
  },
});

export const { openDeleteModal, closeDeleteModal, openEditModal, closeEditModal } =
  adminConsoleConfigControlSlice.actions;
export default adminConsoleConfigControlSlice.reducer;
